module.exports = __webpack_public_path__ + "static/media/icon-question-card-kebab-active.9908a75c.svg";